export const SET_CITIES = "setCities";
export const SET_SELECTED_CITY = "setSelectedCity";
